import { Card, CardHeader } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'

const WorkerCardSkeleton = () => {
  return (
    <Card>
      <CardHeader
        avatar={<Skeleton variant="circular" height={40} width={40} />}
        title={<Skeleton variant="rectangular" height={20} width={240} />}
        subheader={<Skeleton variant="rectangular" height={20} width={130} />}
      />
    </Card>
  )
}

export default WorkerCardSkeleton
